
import type { PropOptions } from 'vue';
import Vue from 'vue';
import BurgerIcon from '~/assets/svg/menu-burger.vue.svg';
import BravadoIconButton from '~/components/common/BravadoIconButton/BravadoIconButton.vue';
import EyeIcon from '~/assets/svg/eye-open.vue.svg';
import ClosedEyeIcon from '~/assets/svg/eye-slash.vue.svg';

export default Vue.extend({
  name: 'PublicPortfolioEditClient',
  components: {
    BravadoIconButton,
    BurgerIcon,
    EyeIcon,
    ClosedEyeIcon,
    IconTrash: () => import('@/components/Icon/Trash.vue'),
  },
  props: {
    image: {
      type: String,
      default: 'https://www.fillmurray.com/32/32',
    } as PropOptions<string>,
    title: {
      type: String,
      default: 'Bravado',
    } as PropOptions<string>,
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    clientClass(): Record<string, boolean> {
      return {
        'public-portfolio-edit-client__client': true,
        'public-portfolio-edit-client__client--opaque': !this.isPublic,
      };
    },
  },
});
